module.exports = __webpack_public_path__ + "img/knet.dca9fb18.png";